import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import {
  CancelButton,
  UpdateButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { publishCycle } from "../../../../../redux/features/appraisalSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import useHandleApiResponse from "../../../../../Hooks/useHandleApiResponse";

const Publish = ({ id }) => {
  const handleApiResponse = useHandleApiResponse();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { loading } = useSelector((state) => state.appraisal);

  const handlePublish = () => {
    dispatch(publishCycle(id)).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          setOpen(false);
        },
        onFailed: () => {
          console.log("Something went wrong");
        },
      });
    });
  };

  return (
    <Box>
      <GlobalDialog
        title={"Send Reminder"}
        open={open}
        setOpen={setOpen}
        closeButton={true}
        popupButton={
          <Button onClick={() => setOpen(true)} size="small" variant="outlined">
            Publish
          </Button>
        }
        content={
          <Box>
            <Typography>Are you sure ? you want to publish..!</Typography>
          </Box>
        }
        actionButton={
          <>
            <CancelButton size={"small"} action={() => setOpen(false)}>
              Cancel
            </CancelButton>
            <UpdateButton
              disabled={loading}
              action={handlePublish}
              size={"small"}
            >
              {loading ? "Please wait..." : "Publish"}
            </UpdateButton>
          </>
        }
      />
    </Box>
  );
};

export default Publish;
